import React, { useState, useEffect } from 'react';
import { callApi, showSweetAlert } from '../../../utils/utils';
import { config } from '../../../utils/config';
import { useTranslation } from 'react-i18next';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Row, Col, Label } from 'reactstrap';
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import FieldDropdown from 'components/Controls/FieldDropdown';
import FieldUpload from 'components/Controls/FieldUpload/FieldUpload';
import * as yup from 'yup';
import YupValidator from '../../../utils/YupValidator';
import FieldAutoComplete from 'components/Controls/FieldAutoComplete';
import FieldToogleSwitch from 'components/Controls/FieldToogleSwitch/FieldToogleSwitch';

const ManageADPEmployeesFilters = (props) => {
  const {t, i18n} = useTranslation(['hr', 'common']);

  const [adpEmployee, setAdpEmployee] = useState(null);
  const [adpEmployees, setAdpEmployees] = useState(null);
  const [company, setCompany] = useState(null);
  const [errors, setErrors] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [showTermedEmployees, setShowTermedEmployees] = useState(true);
  const [reportsTo, setReportsTo] = useState(null);
  const [reportsToSuggestions, setReportsToSuggestions] = useState(null);
  const [showUploadEmployees, setShowUploadEmployees] = useState(false);
  const [file, setFile] = useState([]);

  useEffect(() => {
    getCompanyNames();
  }, [])

  useEffect(() => {
    const onKeyDown = (e) => {
      if(e.keyCode === 13) {
        updateFilters();
      }
    }
    
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [company, adpEmployee, reportsTo, showTermedEmployees])

  const getCompanyNames = () => {
    const urlWebService = `${config.UrlApiProject}HR/GetADPEmployeeCompanyPayrollNames`;
    const paramsService = {};

    callApi(urlWebService, 'GET', paramsService, (response) => {
      console.log(response.data)
      setCompanies(response.data);
    });
  }

  const filterAdpReportsTo = (e) => {
    let valor = ''; 
    if (reportsTo.FullName !== null && reportsTo.FullName !== '' &&  e.query === "")
    {
      valor = reportsTo.FullName;
    }
    else{
      valor = e.query;
    }
    const paramsServiceOwners = {};
    // event.query 
    const urlWebServiceOwners = `${config.UrlApiProject}HR/CmbADPReportsTo?valor=${valor}`;
    // Get owner
    callApi(urlWebServiceOwners, 'GET', paramsServiceOwners, (response) => {  
        setReportsToSuggestions(response.data);
    });    
  }

  const filterAdpEmployee = (e) => {
    let valor = ''; 
    if (adpEmployee.FullName !== null && adpEmployee.FullName !== '' &&  e.query === "")
    {
      valor = adpEmployee.FullName;
    }
    else{
      valor = e.query;
    }
    const paramsServiceOwners = {};
    // event.query 
    const urlWebServiceOwners = `${config.UrlApiProject}HR/CmbADPEmployee?valor=${valor}`;
    // Get owner
    callApi(urlWebServiceOwners, 'GET', paramsServiceOwners, (response) => {  
        setAdpEmployees(response.data);
    });    
  }

  const onAdpEmployeeChange = (e) => {
    const newErrors = {...errors};
    delete newErrors.adpEmployee;
    setErrors(newErrors);
    setAdpEmployee(e.value);
  }

  const onReportsToChange = (e) => {
    const newErrors = {...errors};
    delete newErrors.reportsTo;
    setErrors(newErrors);
    setReportsTo(e.value);
  }

  const onChangeCompany = (e) => {
    console.log(e);
    const newErrors = {...errors};
    delete newErrors.company;
    setErrors(newErrors);
    setCompany(e.value);
  }

  const updateFilters = () => {
    console.log(showTermedEmployees)
    props.setFilters({
      PositionId: adpEmployee !== null && reportsTo !== undefined ? adpEmployee.AssociateId : null,
      CompanyName: company,
      ReportsTo: reportsTo !== null && reportsTo !== undefined ? reportsTo.AssociateId : null,
      ShowTermedEmployees: showTermedEmployees ? 1 : 0
    })
  }

  const clearFilters = () => {
    setCompany(null);
    setReportsTo(null);
    setAdpEmployee(null);
    setShowTermedEmployees(true);
    props.setFilters({ShowTermedEmployees: 1});
  }

  // Download as Excel
  const exportADPEmployeeXlsx = () => {
    const urlWebService = `${config.UrlApiProject}HR/ExportADPEmployeesAsXlsx`;        
    const paramsService = {};
    callApi(urlWebService, 'GET', paramsService, (response) => {
      const linkSource = `data:application/${response.data.FileExtension};base64,${response.data.FileData}`;
      const downloadLink = document.createElement("a");
      const fileName = `${response.data.FileName}`;
      downloadLink.href = linkSource;
      downloadLink.download = `${fileName  }.${  response.data.FileExtension}`;
      downloadLink.click();
    });   
  }

  const onSubmitClick = async () => {
    console.log(file);

    const validationSchema = yup.object().shape({
      file: yup.array().min(1, t('common:RequiredField')).required(t('common:RequiredField')).nullable()
    })

    const value = {
      file
    }

    const validator = new YupValidator(validationSchema);
    const isValid = await validator.validate(value);

    if (!isValid) {
      setErrors(validator.errors);
      showSweetAlert(t('common:Warning'), t('common:ReviewRequiredFields'), 'warning');
      return;
    }

    const urlWebService = `${config.UrlApiProject}HR/ReadEmployeesFromSpreadsheet`;
    const paramsService = {
      FileData: file[0].FileData,
      FileName: file[0].FileName,
      FileExtension: file[0].FileExtension
    }

    callApi(urlWebService, 'POST', paramsService, (response) => {
      setFile([]);
      clearFilters();
      setShowUploadEmployees(false);
      getCompanyNames();
      showSweetAlert('success', t('common:SuccessOperation'), 'success');
    });
  }

  const filterHeaderTemplate = (options) => {
    const toggleIcon = options.collapsed ? 'pi pi-chevron-down text-white' : 'pi pi-chevron-up text-white';
    const className = `${options.className} p-jc-start`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className="card-header">
        <div className="p-toolbar p-component">
          <div className="p-toolbar-group-left">
            <div className="card-title">
              <FieldButton className={options.togglerClassName} onClick={options.onTogglerClick}>
                <span className={toggleIcon}></span> 
              </FieldButton>
              <span className={titleClassName}>
                {t('common:Filters')}
              </span>
            </div>  
          </div>
          <div className="p-toolbar-group-right">
            <FieldButton
              label={t('hr:UploadEmployees')}
              onClick={() => setShowUploadEmployees(true)}
              className='p-button-secondary mr-2'
              icon='pi pi-upload'
            />
            <FieldButton 
              className="p-button-secondary mr-2"
              onClick={() => exportADPEmployeeXlsx()}
              icon='fa fa-file-excel'
              tooltip={t('common:Export')}
            />
            <FieldButton
              onClick={() => updateFilters()}
              className='p-button mr-2'
              icon='pi pi-search'
              tooltip={t('common:Search')}
            />
            <FieldButton
              onClick={() => clearFilters()}
              className='p-button-danger'
              icon='pi pi-times'
              tooltip={t('common:Clear')}
            />
          </div>
        </div> 
      </div>
    )
  }

  const uploadFooter = () => {
    return (
      <>
        <FieldButton label='Submit' onClick={() => onSubmitClick()} icon='pi pi-upload' className='p-button-success' />
      </>
    )
  }

  return (
    <>
      <Panel
        header={t('common:Filters')}
        toggleable
        headerTemplate={filterHeaderTemplate}
      >
        <Row className='p-fluid p-grid p-formgroup-inline align-items-end'>
          <Col xs={12} sm={12} md={4} lg={4} xl={3}>
            <div className='p-field'>
              <Label>{t('hr:Employee')}</Label>
              <FieldAutoComplete
                dropdown
                id="adpEmployee"
                name="adpEmployee"
                value={adpEmployee}
                onChange={onAdpEmployeeChange}
                suggestions={adpEmployees}
                field="IdFullName"
                completeMethod={filterAdpEmployee}
                errors={errors}
              />
            </div>
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={3}>
            <div className='p-field'>
              <Label>{t('hr:PayrollCompany')}</Label>
              <FieldDropdown
                name='company'
                value={company}
                options={companies}
                optionValue="PayrollCompanyName"
                optionLabel="PayrollCompanyName"
                onChange={onChangeCompany}
              />
            </div>
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={3}>
            <div className='p-field'>
              <Label>{t('hr:ReportsTo')}</Label>
              <FieldAutoComplete
                dropdown
                id="adpReportsTo"
                name="adpReportsTo"
                value={reportsTo}
                onChange={onReportsToChange}
                suggestions={reportsToSuggestions}
                field="IdFullName"
                completeMethod={filterAdpReportsTo}
                errors={errors}
              />
            </div>
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} xl={3}>
            <div className='p-field'>
              <Label>{t('hr:ShowTermedEmployees')}</Label>
              <br />
              <FieldToogleSwitch
                id="showTermedEmployees"
                checked={showTermedEmployees}
                onChange={() => setShowTermedEmployees(!showTermedEmployees)} 
                optionLabels={[t('common:Yes'), t('common:No')]}
              />
            </div>
          </Col>
        </Row>
      </Panel>
      <Dialog
        visible={showUploadEmployees}
        onHide={() => {
          setShowUploadEmployees(false);
          setFile([]);
          setErrors(null);
        }}
        footer={uploadFooter}
        blockScroll={true}
        style={{ width: '15vw' }}
        breakpoints={{'1400px': '25vw', '1000px': '35vw', '510px': '50vw', '560px': '100vw' }}
      >
        <FieldUpload
          name='file'
          files={file}
          onChange={(files) => setFile(files)}
          accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          errors={errors}
          uploadPrompt={t('hr:ADPUploadPrompt')}
        >
        </FieldUpload>
      </Dialog>
    </>
  )
}

export default ManageADPEmployeesFilters;